/**
 * Created by Ning Jiang on 2021-05-21.
 */

import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Serial} from "../Serial";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {SerialReelController} from "../reels/SerialReelController";
import {ReelState} from "../../core/reel/ReelState";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Layers, SerialLayers} from "../view/SerialLayers";

export class SerialNormalResultPresentation implements FlowStatePresentation {
    private _reelNormalStopDelay:number[] = [0, 0.3, 0.3, 0.3, 0.3];
    private _reelZeroBetStopDelay:number[] = [0, 0.4, 0.4, 0.4, 0.4];
    private _reelFastStopDelay:number[] = [0, 0.1, 0.1, 0.1, 0.1];
    private _reelNearWinStopDelay:number[] = [3.0, 3.0, 3.0, 3.0, 3.0];
    private _defaultSpinDuration:number;

    constructor() {}

    public start(flowStateController:FlowStateController):void {
        flowStateController.setSkipCallback(() => this.skip());
        Serial.reelStopPresentations.start().then(res => {
            if(!Serial.model.parsedGameData.nextMode.includes("RESPIN")) {
                SerialLayers.getLayer(Layers.NEAR_WIN)!.children.length = 0;
            }
            flowStateController.finish();
        });
        if(!this._defaultSpinDuration) {
            // This simple calculation doesn't cover strange stopping order.
            this._defaultSpinDuration = ArrayHelper.arraySum(this._reelNormalStopDelay) + Serial.reels[4].getDefaultStoppingTime();
        }

        // The spin time should not leak there is feature later, like a near win. so I use a default spin time here to calculation Jurisdiction padding.
        // fastSpin is off when there is spin time limit, so we don't need to consider it here. To change if something changed.
        let delay = 0;
        const padding = Serial.gameFlowController.calculatePaddingDuration(this._defaultSpinDuration);
        if(padding > 0) {
            //Logger.logDev("Added minimum jurisdiction padding  ", padding);
            delay += padding;
        }
        if(delay == 0 && !SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            const spinTime = (Date.now() - Serial.betTime);
            delay = Math.max(800 - spinTime, 0) / 1000;
        }

        this.getReelsStopResult(false, delay);
    }

    protected getReelsStopResult(quickStop:boolean, delay:number):void {
        let spinStopOffset:number = 0;
        Serial.reels.forEach((spinReel:SerialReelController, reelId:number) => {
            if(spinReel.reelState === ReelState.SPIN) {
                spinStopOffset = Math.max(
                    spinStopOffset,
                    spinReel.getSpinStopOffset());
            }
        });

        Serial.reels.forEach((reel, reelId) => {
            delay += this.getReelStopDelay(reel, quickStop); // This is a rough estimated time, the reel will take the real time when it's stopping.
            const enhancerStopDelay = this.getEnhancerStopDelay(reel.reelId, quickStop);
            reel.tryStop(spinStopOffset, delay, quickStop);
            delay += enhancerStopDelay;
        });
    }

    private getReelStopDelay(reel:SerialReelController, quickStop:boolean):number {
        if(reel.reelState === ReelState.INACTIVE || reel.reelState === ReelState.STOPPING || reel.reelState === ReelState.STOPPED) {
            return 0;
        }

        if(quickStop) {
            return this._reelFastStopDelay[reel.reelId];
        }

        if(reel.hasNearWin()) {
            return this._reelNearWinStopDelay[reel.reelId];
        }

        if(Serial.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            return this._reelFastStopDelay[reel.reelId];
        }

        if(Serial.model.parsedGameData.mode === GameMode.NORMAL) {
            return this._reelNormalStopDelay[reel.reelId];
        }

        return this._reelZeroBetStopDelay[reel.reelId];
    }

    private getEnhancerStopDelay(reelId:number, quickStop:boolean):number {
        if(this.isEnhancerSpinning(reelId, 0) ||
            this.isEnhancerSpinning(reelId, 1) ||
            this.isEnhancerSpinning(reelId, 5) ||
            this.isEnhancerSpinning(reelId, 6)) {
            return 0.1;
        }
        return 0;
    }

    private isEnhancerSpinning(reelId:number, positionId:number):boolean {
        return Serial.model.currentSpinPositions[reelId][positionId] && Serial.enhancerReels[reelId][positionId].isOpened;
    }

    private skip():void {
        Logger.logDev("skip result");
        this.getReelsStopResult(true, 0);
        Serial.reelStopPresentations.skip();
    }
}